class ScrollInto {


  init() {
    $('.js--scroll-into').click((e) =>  {
      e.preventDefault();

      let $scrollTo = $(e.currentTarget.getAttribute('href'));
      if($scrollTo.length < 1) {
        return false;
      }

      $("html, body").animate({scrollTop:$scrollTo.offset().top}, '500');
    });

  }

}

export { ScrollInto };
